import { useStore } from 'effector-react';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { sessionConfig$ } from 'model/session.model';
import { h } from 'preact';

import { HiveIcon } from 'ui/icons/hive-icon';

export const Footer = () => {
	const session = useStore(sessionConfig$);
	const url = session ? session.urls.hive_link_url : 'https://hive.id';
	const isHiveLink = session ? session.hive_link : false;

	return (
		<FooterWrapper>
			{isHiveLink && (
				<a className={link} href={url} target={'_blank'}>
					<span>Powered by</span>
					<HiveIcon/>
				</a>
			)}
		</FooterWrapper>
	);
};

const link = css`
	display: flex;
	padding: 5px 6px;
	border-radius: 4px;
	transition: .2s ease-in-out;
	color: var(--whitelabel-hover);
	
	&:hover {
    transition: .2s ease-in-out;
    color: var(--whitelabel-hover-text);
		
		span {
			transition: .2s ease-in-out;
			color: var(--whitelabel-hover-text);
		}
		
		svg {
			transition: .2s ease-in-out;
			color: var(--whitelabel-hover-text);
		}
	}
`;
const FooterWrapper = styled('div')`
	display: flex;
	justify-content: center;
	margin-top: auto;
	padding: 0 0 8px;
	min-height: 38px;

	span {
		margin-right: 8px;
		color: var(--text-tertiary);
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 20px;
	}

	svg {
		color: var(--text-tertiary);
	}
`;
